// Conversa com a balança pelo cabo (Web Serial: Chrome e Edge no computador e
// o Núcleo Desktop a partir da versão com balança). Mantém a porta aberta e
// lendo; `pedir()` manda o ENQ (se a balança trabalha por pedido) e espera a
// próxima resposta. Balança contínua não precisa do ENQ: vale o último quadro.
import { ENQ, separarQuadros, ultimaLeitura } from "./protocolo";

const ESPERA_MS = 900;

export function webSerialDisponivel() {
  return typeof navigator !== "undefined" && !!navigator.serial;
}

export function infoDaPorta(port) {
  const i = (port && port.getInfo && port.getInfo()) || {};
  return { usbVendorId: i.usbVendorId ?? null, usbProductId: i.usbProductId ?? null };
}

/** Porta já autorizada que bate com a salva (ou a única autorizada). */
export async function portaSalva(salva) {
  if (!webSerialDisponivel()) return null;
  const portas = await navigator.serial.getPorts();
  if (!portas.length) return null;
  if (salva && salva.usbVendorId != null) {
    const igual = portas.find((p) => {
      const i = infoDaPorta(p);
      return i.usbVendorId === salva.usbVendorId && i.usbProductId === salva.usbProductId;
    });
    if (igual) return igual;
  }
  return portas[0];
}

export async function abrirCabo(port, cfg) {
  await port.open({
    baudRate: Number(cfg.baudRate) || 9600,
    dataBits: Number(cfg.dataBits) || 8,
    stopBits: Number(cfg.stopBits) || 1,
    parity: cfg.parity || "none",
    bufferSize: 1024,
  });
  let buffer = [];
  let ultima = null;
  let esperando = [];
  let fechado = false;
  const reader = port.readable.getReader();
  const writer = port.writable ? port.writable.getWriter() : null;

  (async () => {
    try {
      while (!fechado) {
        const { value, done } = await reader.read();
        if (done) break;
        if (!value) continue;
        buffer = buffer.concat(Array.from(value)).slice(-512);
        const { quadros, resto } = separarQuadros(buffer);
        buffer = resto;
        const leitura = quadros.length ? ultimaLeitura(quadros, { casas: Number(cfg.casas) || 3 }) : null;
        if (leitura) {
          ultima = { ...leitura, em: Date.now() };
          const fila = esperando;
          esperando = [];
          fila.forEach((fn) => fn(ultima));
        }
      }
    } catch {
      /* cabo puxado ou porta fechada: a próxima leitura reabre */
    }
  })();

  const proxima = (ms) => new Promise((resolve) => {
    const t = setTimeout(() => {
      esperando = esperando.filter((f) => f !== fn);
      resolve(null);
    }, ms);
    const fn = (l) => { clearTimeout(t); resolve(l); };
    esperando.push(fn);
  });

  return {
    tipo: "cabo",
    async pedir() {
      if (cfg.pedirPeso && writer) {
        try { await writer.write(new Uint8Array([ENQ])); } catch { return { estado: "sem_resposta", kg: null }; }
      } else if (ultima && Date.now() - ultima.em < 500) {
        return ultima;
      }
      const l = await proxima(ESPERA_MS);
      return l || { estado: "sem_resposta", kg: null };
    },
    async fechar() {
      fechado = true;
      try { await reader.cancel(); } catch { /* já fechado */ }
      try { reader.releaseLock(); } catch { /* idem */ }
      try { writer && writer.releaseLock(); } catch { /* idem */ }
      try { await port.close(); } catch { /* idem */ }
    },
  };
}
